import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Api, getExtendedRequestConfig, handleError } from './actions/fetch';
import './form.css';
import './homepage/Homepage.css';

function FeedbackForm() {
  const { t } = useTranslation('account');
  const reduxStore = useSelector(state => state, shallowEqual);
  const history = useHistory();

  const [hasContent, setHasContent] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(undefined);

  const active = useRef(true);
  const feedbackElement = useRef(true);
  const dataCheckboxElement = useRef(true);

  useEffect(() => {
    return () => {
      active.current = false;
    } 
  }, []);

  function validate() {
    setHasContent(!!feedbackElement.current.value.length);
  }

  function processForm(event) {
    event.preventDefault();
    if (processing) {
      return;
    }
    setProcessing(true);
  
    fetch(`${Api}/feedback`, getExtendedRequestConfig({ params: {
      method: 'POST',
      body: {
        message: feedbackElement.current.value,
        data: dataCheckboxElement.current.checked ? reduxStore : undefined,
      },
    }}))
    .then(handleError)
    .then(() => {
      if (!active.current) {
        // We have been unmounted already
        return;
      }
      setProcessing(false);
      history.push({ pathname: '/thankyou' });
    })
    .catch((error) => {
      if (!active.current) {
        // We have been unmounted already
        return;
      }
      setProcessing(false);
      setError(error);
    });
  }

  return (
    <Fragment>
      <main id="feedback" className={`textPage ${processing ? 'processing' : ''}`}>
        <h1>{t('feedback.heading')}</h1>
        <p>{t('feedback.prompt')}</p>
        <form onSubmit={processForm}>
          <textarea
            ref={feedbackElement}
            name="feedback"
            onChange={validate}
          />
          <input
            ref={dataCheckboxElement}
            id="data"
            type="checkbox"
            name="data"
          />
          <label htmlFor="data" className="inline">{t('feedback.includeData')}</label>
          <p><small>{t('feedback.wait')}</small></p>
          <input
            type="submit"
            disabled={!hasContent || processing}
            value={t('feedback.submit')}
          />
        </form>
        { error
        ? <p className="error">{error.message || JSON.stringify(error)}</p>
        : undefined
        }
      </main>
    </Fragment>
  );
}

export default FeedbackForm;
